export var MATFILE_ENDLESS_TYPE = 'ENDLESS';
export var MATFILE_DIECUT_TYPE = 'DIECUT';
export var MATFILE_PLATE_TYPE = 'PLATE';
export var MATFILE_SHEET_TYPE = 'SHEET';
export var MATFILE_LASER_TYPE = 'LS';
